import D2C_TariffOption from './Option'

class D2C_TariffExtraMembers extends D2C_TariffOption {
  static objectType = 'tariffType'
  static active = true
  static tariffId = '5b7176b6bf716b53f1221803'
  static tariffTitle = 'Extra members'
}

export default D2C_TariffExtraMembers
